export const API_BASE_URL = 'https://cleaningmiamipanel.org/api'

export const authHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`
});

export const authFetch = (url, options = {}) =>
    fetch(url, {
        ...options, 
        headers: {
            ...authHeaders(),
            ...options.headers
        }
    }).then(res => res.json());